// extracted by mini-css-extract-plugin
module.exports = {"row":"WorkspaceSummaryRow_row__X4U9w"};